module.exports = __webpack_public_path__ + "static/img/statusCom.9d359ffa.png";